import { USER_REQUEST, USER_ERROR, USER_SUCCESS } from '../actions/user';
// import apiCall from '@/utils/api';
import Vue from 'vue';
import { AUTH_LOGOUT } from '../actions/auth';

const state = {
	status: '',
	profile: {},
	id: null,
	isCommissioner: false,
	name: '',
};

const getters = {
	getProfile: state => state.profile,
	isProfileLoaded: state => !!state.profile.name,
	isMyTurn: (state, getters, rootState) =>
		rootState.current_picker.id === state.id,
};

const actions = {
	[USER_REQUEST]: ({ commit, dispatch }) => {
		// commit(USER_REQUEST);
		// apiCall({
		// 	url: '/api/v1/rooms/1/user_rosters/current_user_roster',
		// })
		// 	.then(resp => {
		// 		commit(USER_SUCCESS, resp);
		// 	})
		// 	.catch(() => {
		// 		commit(USER_ERROR);
		// 		// if resp is unauthorized, logout, to
		// 		dispatch(AUTH_LOGOUT);
		// 	});
	},
};

const mutations = {
	[USER_REQUEST]: state => {
		state.status = 'loading';
	},
	[USER_SUCCESS]: (state, resp) => {
		state.status = 'success';
		Vue.set(state, 'profile', resp);
	},
	[USER_ERROR]: state => {
		state.status = 'error';
	},
	[AUTH_LOGOUT]: state => {
		state.profile = {};
	},
	set_current_user_id(state, payload) {
		state.id = payload;
	},
	set_current_commissioner_status(state, payload) {
		state.isCommissioner = payload;
	},
	set_current_user_name(state, payload) {
		state.name = payload;
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
